// TODO: Remove this file when ORF forms printed materials will be updated
const FORM_NAMES_MAP = {
    '50726F6772657373204D6F6E69746F72696E67204F52462E352E317C7C7C31':
        'Form 1_Amplify Printed Kit Version',
    '50726F6772657373204D6F6E69746F72696E67204F52462E352E315F446F776E6C6F61646564205044467C7C7C31':
        'Form 1_Downloaded PDF',
};

export const FORMS_NAMES_HISTORY_MAP = {
    '50726F6772657373204D6F6E69746F72696E67204F52462E352E317C7C7C31': 'F1_Kit',
    '50726F6772657373204D6F6E69746F72696E67204F52462E352E315F446F776E6C6F61646564205044467C7C7C31':
        'F1_PDF',
};

export const FORMS_UID = {
    F1_KIT: '50726F6772657373204D6F6E69746F72696E67204F52462E352E317C7C7C31',
    F1_PDF:
        '50726F6772657373204D6F6E69746F72696E67204F52462E352E315F446F776E6C6F61646564205044467C7C7C31',
};

export const F1_KIT_FORM_LABEL = 'F1_Kit';

export const FORM_SOURCE = {
    BM: {
        id: 'bm',
        name: 'Reuse the Benchmark form.',
    },
    PM: {
        id: 'pm',
        name: 'Select a Progress Monitoring form instead.',
    },
};

export default FORM_NAMES_MAP;
